module.exports = __webpack_public_path__ + "img/logo.ed84d668.png";